import { render, staticRenderFns } from "./VirtualAccountReqList.vue?vue&type=template&id=7ed080fa&scoped=true"
import script from "./VirtualAccountReqList.vue?vue&type=script&lang=js"
export * from "./VirtualAccountReqList.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountReqList.vue?vue&type=style&index=0&id=7ed080fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed080fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed080fa')) {
      api.createRecord('7ed080fa', component.options)
    } else {
      api.reload('7ed080fa', component.options)
    }
    module.hot.accept("./VirtualAccountReqList.vue?vue&type=template&id=7ed080fa&scoped=true", function () {
      api.rerender('7ed080fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/VirtualAccountReqList.vue"
export default component.exports